import * as manualTaxMappings from '@wix/auto_sdk_billing_manual-tax-mappings';

export { manualTaxMappings };
